import WithGASetup from '../../components/WithGASetup';
import AuthContext from '../../context/AuthContext.js';
import InvitePatientPage from './InvitePatientPage.js';

export default WithGASetup(InvitePatientPage, AuthContext);
